// app/core/disable-nav-when-edit.ts
import { Injectable } from '@angular/core';
import { EditorService } from '@modules/editor/services/editor.service';

@Injectable({ providedIn: 'root' })
export class DisableNavWhenEdit {
  constructor(private editor: EditorService) {
    document.addEventListener(
      'click',
      (ev: MouseEvent) => {
        if (!this.editor.isEditModeEnabled()) {
          return;
        }

        // Jeśli kliknięto toolbar lub jego dziecko — nie blokujemy!
        if ((ev.target as HTMLElement).closest('.ite-toolbar')) {
          return;
        }

        const link = (ev.target as HTMLElement).closest('a');
        if (!link) {
          return;
        }

        // Standardowe blokowanie
        ev.preventDefault();
        const isRouterLink =
          link.hasAttribute('routerLink') ||
          link.hasAttribute('routerLinkActive') ||
          link.getAttribute('_ngcontent') !== null;
        if (isRouterLink) {
          ev.stopImmediatePropagation();
        }
      },
      true
    );
  }
}
